import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Table, Pagination, Popconfirm, Space, Select, Row, Col, Modal, message } from 'antd';
import { DeleteOutlined, FormOutlined, RedoOutlined, SearchOutlined, PlusOutlined } from '@ant-design/icons';
import _axios from '../unit/axios';

function Student() {

    let isinit = false;
    useEffect(() => {
        if (!isinit) {
            // getList();
            // getSchool();
            isinit = true;
        }

    }, [])

    const [loading, setLoading] = useState(false);
    const seachource = useRef({});
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [searchForm] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const getList = async () => {
        var p = {
            page,
            size,
            ...seachource.current,
        }
        setLoading(true);
        _axios.get('/api.v1/member/list', { params: p }).then(res => {
            for (var s of res.data.list || []) {
                s.sex = s.sex.toString();
                s.school = s.school.toString();
            }
            setList(res.data.list || []);
            setTotal(res.data.total || 0);
            setLoading(false);
        }).catch(err => {
            console.log(err)
            setLoading(false);
        })
    }

    const [schoolList, setSchoolList] = useState({});
    const getSchool = () => {
        var p = {
            page: 1,
            size: 100,
        }
        _axios.get('/api.v1/school/list', { params: p }).then(res => {
            var s = {};
            for (var school of res.data.list || []) {
                s[school.id] = school.name;
            }
            setSchoolList(s);
        }).catch(err => {
            console.log(err)
        })
    }

    useEffect(() => {
        getList();
    }, [page, size])

    const onFinish = (values) => {
        console.log('Success:', values);
        for (const key in values) {
            if (values[key] === null || values[key] === undefined) {
                delete values[key];
            }
        }
        seachource.current = values;
        page == 1 ? getList() : setPage(1);
    };

    const columns = [{
        title: '姓名',
        dataIndex: 'name',
        key: 'name',
    }, {
        title: '帐号',
        dataIndex: 'account',
        key: 'account',
    }, {
        title: '学校',
        dataIndex: 'school',
        key: 'school',
        render: function (text, record) {
            return schoolList[record.school] || ''
        }
    }, {
        title: '性别',
        dataIndex: 'sex',
        key: 'sex',
        render: function (text, record) {
            return record.sex == 1 ? '男' : (record.sex == 2 ? '女' : '')
        }
    }, {
        title: '年龄',
        dataIndex: 'age',
        key: 'age',
    }, {
        title: '操作',
        key: 'action',
        width: '180px',
        align: 'center',
        render: (_, record) => {
            return <Space size="middle">
                {(user.id == '3' || auth.includes('student-edit')) && <Button color="primary" variant="solid" size="small" onClick={() => showModal('edit', record)}><FormOutlined />修改</Button>}
                {(user.id == '3' || auth.includes('student-del')) && <Popconfirm title="系统提示" description="确定删除该数据吗？" okText="确定" cancelText="取消" onConfirm={() => deleteRow(record)}>
                    <Button color="danger" variant="solid" size="small" disabled={loading}><DeleteOutlined />删除</Button>
                </Popconfirm>}
            </Space>
        },
    }]

    const [form] = Form.useForm();
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState({});
    const showModal = (type = 'add', row) => {
        var data = { name: '', school: '', account: '', password: '', sex: '', age: '', type };
        if (row) {
            data = Object.assign(data, row);
        }
        form.setFieldsValue(data);
        setModalData(data);
        setModalShow(true);
    }

    const deleteRow = (row) => {
        setLoading(true);
        _axios.delete('/api.v1/member', { data: { id: row.id } }).then(res => {
            messageApi.open({
                type: 'success',
                content: '删除成功',
            })
            setDelModalShow(false);
            setLoading(false);
            page == 1 ? getList() : setPage(1);
        }).catch(err => {
            messageApi.open({
                type: 'error',
                content: '删除失败',
            })
            setLoading(false);
        })
    }

    const save = () => {
        form.submit();
    }

    const submit = (values) => {
        setLoading(true);
        var p = Object.assign(modalData, values);
        _axios.put('/api.v1/member', p).then(res => {
            messageApi.open({
                type: 'success',
                content: '提交成功',
            })
            setModalShow(false);
            setLoading(false);
            page == 1 ? getList() : setPage(1);
        }).catch(err => {
            messageApi.open({
                type: 'error',
                content: '提交失败',
            })
            setLoading(false);
        })
    }

    return (
        <>
            <iframe src={'http://www.childrenassessment.com.cn/student-list'} style={{ flex: '1', }} />
        </>
        // <div style={{ padding: '20px', flex: '1',  }}>
        //     <Form form={searchForm} onFinish={onFinish} autoComplete="off" layout="inline" style={{ borderBottom: '1px solid #ccc', marginBottom: '20px', display: 'block' }}>
        //         <Row>
        //             <Col span={6} style={{ marginBottom: '20px' }}>
        //                 <Form.Item label="姓名" name="name">
        //                     <Input />
        //                 </Form.Item>
        //             </Col>
        //             <Col span={6} style={{ marginBottom: '20px' }}>
        //                 <Form.Item label="帐号" name="account">
        //                     <Input />
        //                 </Form.Item>
        //             </Col>
        //             <Col span={6} style={{ marginBottom: '20px' }}>
        //                 <Form.Item label="学校" name="school">
        //                     <Select >
        //                         {Object.keys(schoolList).map((key) => (
        //                             <Select.Option value={key} key={`s-s${key}`}>{ schoolList[key] }</Select.Option>
        //                         ))}
        //                     </Select>
        //                 </Form.Item>
        //             </Col>
        //             <Col span={6} style={{ marginBottom: '20px' }}>
        //                 <Form.Item>
        //                     <Button onClick={() => { searchForm.resetFields(); }} style={{ marginRight: '12px' }}>
        //                         <RedoOutlined />重置
        //                     </Button>
        //                     <Button color="primary" variant="solid" htmlType="submit" disabled={loading} style={{ marginRight: '12px' }}>
        //                         <SearchOutlined />查询
        //                     </Button>
        //                     {(user.id == '3' || auth.includes('student-add')) && <Button color="primary" variant="filled" onClick={() => showModal()}>
        //                         <PlusOutlined />新增
        //                     </Button>}
        //                 </Form.Item>
        //             </Col>
        //         </Row>
        //     </Form>

        //     <Table dataSource={list} columns={columns} pagination={false} rowKey="id"></Table>

        //     <div style={{ marginTop: '20px' }}>
        //         <Pagination current={page} pageSize={size} total={total} align='end'
        //             onChange={(page, size) => {
        //                 setPage(page);
        //                 setSize(size);
        //             }}
        //         />
        //     </div>

        //     <Modal title={modalData.type == 'add' ? '新增' : '修改'} open={modalShow} onOk={save} onCancel={() => setModalShow(false)} okText="提交" cancelText="取消">
        //         <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} onFinish={submit} autoComplete="off" disabled={loading}>
        //             <Form.Item label="学校" name="school" rules={[{ required: true, message: '学校不能为空' }]}>
        //                 <Select>
        //                     {Object.keys(schoolList).map((key) => (
        //                         <Select.Option value={key} key={`s-s${key}`}>{ schoolList[key] }</Select.Option>
        //                     ))}
        //                 </Select>
        //             </Form.Item>
        //             <Form.Item label="姓名" name="name" rules={[{ required: true, message: '名称不能为空' }]}>
        //                 <Input />
        //             </Form.Item>
        //             <Form.Item label="帐号" name="account" rules={[{ required: true, message: '帐号不能为空' }]}>
        //                 <Input />
        //             </Form.Item>
        //             <Form.Item label="密码" name="password" rules={[{ required: true, message: '密码不能为空' }]}>
        //                 <Input />
        //             </Form.Item>
        //             <Form.Item label="性别" name="sex">
        //                 <Select >
        //                     <Select.Option value="1">男</Select.Option>
        //                     <Select.Option value="2">女</Select.Option>
        //                 </Select>
        //             </Form.Item>
        //             <Form.Item label="年龄" name="age">
        //                 <Input />
        //             </Form.Item>
        //         </Form>
        //     </Modal>

        //     {contextHolder}
        // </div>

    )
}
export default Student;